import React, { useContext, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FormaDePagamentoContext } from 'contexts/FormaDePagamentoContext';
import { GridContext } from 'contexts/GridContext';
import { useModal, useDialog } from 'components/Modals';
import DeleteModal from 'components/Modals/DeleteModal';
import ResumoModal from 'components/Modals/ResumoModal';
import Container from 'components/Container';
import Header from 'components/Header';
import Card from 'components/Card';
import DataView, { useDataViewFilters } from 'components/DataView';
import CondicoesModal from './Modals/CondicoesModal';
import getFormaDePagamentoFilterFields from './filterFields';

const FormaDePagamento = () => {
  const rotina = 'FormaDePagamento';
  const titulo = 'Formas de Pagamento';
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { openDialog, closeDialog } = useDialog();
  const { openModal, closeModal } = useModal();
  const { deleteGrid, exportPdf, exportXls } = useContext(GridContext);
  const { formaDePagamento, getFormaDePagamento, getLoading } = useContext(
    FormaDePagamentoContext
  );
  const filterFields = useMemo(() => getFormaDePagamentoFilterFields(), []);

  const { applyFilter, filterForm } = useDataViewFilters({
    fields: filterFields,
    searchParams,
    setSearchParams,
    onApply: (props) => loadGrid(props),
  });
  const { getValues } = filterForm;

  const loadGrid = (props = {}) => {
    const filter = props?.filter || getValues();

    closeDialog();
    closeModal();

    getFormaDePagamento({ ...props, rotina, filter });
  };

  const toolbarActions = [
    {
      name: 'Adicionar',
      icon: 'add',
      placement: 'primary',
      action: () => navigate('/app/Tabelas/FormasDePagamento/Manutencao'),
    },
    {
      name: 'Exportar PDF',
      icon: 'file_download',
      action: () =>
        exportPdf({
          rotina,
          filter: getValues(),
          order: formaDePagamento?.order,
        }),
    },
    {
      name: 'Exportar XLS',
      icon: 'file_download',
      action: () =>
        exportXls({
          rotina,
          filter: getValues(),
          order: formaDePagamento?.order,
        }),
    },
    {
      name: 'Resumo',
      icon: 'summarize',
      action: () =>
        openModal(
          <ResumoModal
            colunas={formaDePagamento?.colunas}
            onSubmit={(group) =>
              navigate('/app/Resumo', {
                state: { rotina, group, filter: getValues() },
              })
            }
          />
        ),
    },
  ];

  const rowActions = [
    {
      name: 'Editar',
      icon: 'edit',
      action: ({ row: values }) =>
        navigate('/app/Tabelas/FormasDePagamento/Manutencao', {
          state: { values },
        }),
    },
    {
      name: 'Deletar',
      icon: 'delete',
      action: ({ row }) =>
        openModal(
          <DeleteModal
            onSubmit={() =>
              deleteGrid({
                params: { rotina, id: row?.id },
                cb: () => {
                  loadGrid();
                },
              })
            }
          />
        ),
    },
    {
      name: 'Condições de Pagamento',
      icon: 'currency_exchange',
      menu: true,
      action: ({ row }) =>
        openDialog(
          <CondicoesModal item={row} />,
          'Vínculos entre Formas e Condições'
        ),
    },
    {
      name: 'Boleto',
      icon: 'request_page',
      menu: true,
      action: ({ row }) =>
        navigate('/app/Tabelas/FormasDePagamento/Boleto', { state: row }),
    },
  ];

  return (
    <Container fillHeight>
      <Header
        rotina={rotina}
        titulo={titulo}
        colunas={formaDePagamento?.colunas}
      />
      <Card fillHeight>
        <DataView
          fillHeight
          grid={formaDePagamento}
          filterFields={filterFields}
          filterForm={filterForm}
          onFilter={applyFilter}
          toolbarActions={toolbarActions}
          rowActions={rowActions}
          checkboxSelection
          loading={getLoading}
          loadGrid={loadGrid}
        />
      </Card>
    </Container>
  );
};

export default FormaDePagamento;

